var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Calendar',{attrs:{"darkTheme":_vm.darkTheme},on:{"gotMedia":_vm.setMedia,"startLoad":_vm.startLoadAnim}}),(_vm.isLoading)?_c('Loading'):_vm._e(),(_vm.media && !_vm.isLoading)?_c('Media',{attrs:{"media":_vm.media}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }